export default function($) {
  const homeSwiper = new Swiper('.js-home-slider', {
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: {
      el: ".home-swiper-pagination",
      clickable: true,
    },
    loop: true,
    breakpoints: {
      1024: {
        spaceBetween: 32,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    }
  })
}
